import React from 'react';
import { useDeviceState } from '../service';
import { Skeleton } from 'components/shadcn/ui/skeleton';

const ModuleData = () => {
    const { data: deviceState, isLoading } = useDeviceState();

    const dataLabels = {
        SoC: 'State of Charge',
        SoH: 'State of Health',
        minTempPos: 'Min Temp Position',
        maxTempPos: 'Max Temp Position',
        minVoltPos: 'Min Voltage Position',
        maxVoltPos: 'Max Voltage Position',
        temp_c: 'Average Temp',
        highestTemp: 'Highest Temp',
        charging: 'Charging State',
        current: 'Current',
    };

    return isLoading ? (
        <div className="grid grid-cols-2 gap-3 p-5 md:grid-cols-2 lg:grid-cols-4">
            {Object.keys(dataLabels).map((key) => (
                <Skeleton key={key} className="h-5 w-full" />
            ))}
        </div>
    ) : !deviceState || Object.keys(deviceState).length === 0 ? (
        <p className="text-sm font-medium">No data available</p>
    ) : (
        <div className="grid grid-cols-2 gap-3 p-5 md:grid-cols-2 lg:grid-cols-4">
            {Object.entries(dataLabels).map(([key, value]) => (
                <div key={key} className="flex w-full">
                    <h6 className="text-sm font-semibold">{value}:</h6>
                    <p className="ml-3 text-sm">
                        {deviceState?.[key] ?? 'N/A'}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default ModuleData;
